import { apiClient } from '../../api/client';
import type { components } from '../../api/generated/schema';
import type { NotificationSetting } from '../../domain/notifications';
import { mapped } from '../errors';
import type { NotificationsRepository } from './NotificationsRepository';
import { toNotificationSetting, toNotificationSettingRequest } from './mapping';

type S = components['schemas'];

const PATH = '/api/v1/notification-settings/';

export const httpNotificationsRepository: NotificationsRepository = {
  settings: () =>
    mapped(async () =>
      (await apiClient.get<S['NotificationSetting'][]>(PATH)).map(toNotificationSetting),
    ),
  updateSettings: (settings: NotificationSetting[]) =>
    mapped(async () =>
      (
        await apiClient.send<S['NotificationSetting'][]>(
          'PUT',
          PATH,
          settings.map(toNotificationSettingRequest),
        )
      ).map(toNotificationSetting),
    ),
};
